export default "__VITE_ASSET__DjZk9$EM__"